<template>
  <div class="main-footer">
    <div class="footer-banner-line" v-if="bannerLine">
      <el-row>
        <el-col :span="2"><svgLineLogo/></el-col>
        <el-col :span="20"> 
          <p class="topic-line">{{ $t('footer.topic-line-banner') }}</p>
          <div class="label-line">
             {{ $t('footer.label-line-banner') }} <br>
             {{ $t('footer.label-line-banner-1') }}
          </div>
          <el-button class="btn-line" @click="gotoProfile()">
            <span> <iconLink style="margin-right: 8px;"/> {{ $t('footer.btn-line') }} </span>
            
          </el-button>
        </el-col>
        <el-col :span="2"><iconX class="can-click" @click="setBannerLine(false)" /></el-col>
      </el-row>
    </div>
    <div class="main-footer-body">
      <div
        v-for="(menu, index) in menu_list"
        :key="index"
        :class="[
          'main-footer--tabs',
          { active: isCurrentRoute(menu.route_to) },
        ]"
        @click="toRoute(menu.route_to)"
      >
        <div :class="['main-footer--tab']">
          <img
            v-if="!isCurrentRoute(menu.route_to)"
            :src="require(`@/assets/svg/${menu.icon}?inline`)"
          />
          <div v-else>
            <home-active v-if="menu.route_to.name == 'Home'" />
            <coupon-active v-else-if="menu.route_to.name == 'Coupon'" />
            <profile-active v-else-if="menu.route_to.name == 'Account'" />
            <member-card-active v-else-if="menu.route_to.name == 'Card'" />
          </div>
          <div class="main-footer--title">{{ menu.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters ,mapMutations} from "vuex";
import CouponActive from "@/components/icons/CouponActive.vue";
import HomeActive from "@/components/icons/HomeActive.vue";
import ProfileActive from "@/components/icons/ProfileActive.vue";
import GATracking from "@/helper/GATrackingMixins";
const SvgLineLogo = () => import("@/assets/svg/line_logo.svg");
const iconX = () => import("@/assets/svg/x.svg");
const iconLink = () => import("@/assets/svg/link.svg");
import MemberCardActive from "@/components/icons/MemberCardActive.vue";

export default {
  components: {
    CouponActive,
    HomeActive,
    ProfileActive,
    SvgLineLogo,
    iconX,
    iconLink,
    MemberCardActive,
  },
  mixins: [GATracking],
  data() {
    return {
      menu_list: [
        {
          name: this.$t('components.home-menu'),
          icon: "home.svg",
          icon_active: "home",
          route_to: {
            name: "Home",
            params: {
              restaurant_aliase:
                this.$store.getters["restaurant/restaurantUUID"],
              branch_aliase: this.$store.getters["branch/branchUUID"],
            },
          },
        },
        {
          name: this.$t('coupon.coupon-mine'),
          icon: "coupon.svg",
          icon_active: "coupon",
          route_to: { name: "Coupon" },
        },
        {
          name: this.$t('my-card.my-card'),
          icon: "member-card.svg",
          icon_active: "member-card",
          route_to: { name: "Card" },
        },
        {
          name: this.$t('account.account-mine'),
          icon: "profile.svg",
          icon_active: "profile",
          route_to: { name: "Account" },
        },
      ],
    };
  },
  methods: {
    ...mapMutations({
      setBannerLine: "restaurant/SET_BANNER_LINE"
    }),
    isCurrentRoute(route_to) {
      return this.currentRouteName === route_to.name;
    },
    toRoute(routerTo) {
      if (routerTo.name !== this.currentRouteName) {
        switch (routerTo.name) {
          case 'Home':
            this.trackActivity(2, 'CRMPromotionList');
            break;
          case 'Coupon':
            this.trackReward(2, 'CRMMyCoupon');
            break;
          case 'Account':
            this.trackAccount(2, 'ProfileCRM');
            break;
        }
        this.$router.push(routerTo);
      }
    },
    gotoProfile(){
      this.$router.push({ name: "ProfileSetting" });
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    ...mapGetters({
      restaurantInfo: "restaurant/restaurantInfo",
      bannerLine : "restaurant/bannerLine",
    }),
  },
};
</script>

<style scoped>
.main-footer {
  position: fixed;
  bottom: 0;
  z-index: 2;
  width: 100%;
  max-width: var(--max-width-app);
  box-shadow: 0px -4px 12px rgba(0, 0, 0, 0.04);
}

.main-footer--tabs {
  width: 33%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-footer--tab {
  text-align: center;
}

.main-footer--tab:hover {
  background: unset;
}

.main-footer--tabs.active .main-footer--title {
  color: var(--primary);
  font-weight: 500;
}

.main-footer--title {
  color: #979797;
}
.main-footer-body{
  display: flex;
  justify-content: space-between;
  height: 60px;
  background: #ffffff;
}

.footer-banner-line{
  background: #06C755;
  padding: 16px 8px;
  color: #ffffff;
  font-family: 'DB Heavent';
}
p.topic-line{
  font-size: 20px;
  font-weight: 500;
  margin: 0 0 12px;
}
.label-line{
  font-weight: 400;
  font-size: 18px;
  margin: 0 0 12px;
}
.btn-line{
  border: 1px solid #FFFFFF;
  border-radius: 8px;
  color: #FFFFFF;
  background-color: #06C755;
  width: min-content;
  height: 32px;
  padding: 4px 16px;
  font-family: 'DB Heavent';
  font-size: 18px;
  
}
.btn-line span{
  display: flex;
  align-items: center;
}
.can-click{
  cursor: pointer;
}

</style>

